import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createPhonesFilterConfig(): FilterStringConfig {
  return {
    label: 'Phones',
    icon: <RESOURCE_CORE_FIELD_ICONS.phone_numbers className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: 'Search phones'
    }
  };
}
